import axios from "axios";

export default {

    namespaced: true,

    state: {
        myShortlist: [],
        fullshortlist: [],
        showShortlist: false
    },
    getters: {},
    actions: {
        remove({state, commit}, id) {
            const index = state.myShortlist.findIndex(str => str == id)
            commit("REMOVE_LIST", index)
            const index1 = state.fullshortlist.findIndex(str => str.ISIN == id)
            commit("REMOVE_FULLLIST", index1)
        },
        getShortlist({state, commit, rootState}) {
            if (state.showShortlist === true) {
                axios.get('/search/shortlist', {
                    params: {
                        shortlist: state.myShortlist,
                        order1: rootState.search.order1,
                        order2: rootState.search.order2,
                        sortDir1: rootState.search.sortDir1,
                        sortDir2: rootState.search.sortDir2,
                        native: rootState.search.currency,
                        isin_benchmark: rootState.search.compareBenchmarkFilter
                    }
                })
                    .then((response) => {
                        commit("SET_FULL_SHORTLIST", response.data.data)
                    })
                    .catch(() => {
                    })
            }

        }
    },
    mutations: {
        REMOVE_LIST(state, n) {
            state.myShortlist.splice(n, 1)
        },
        REMOVE_FULLLIST(state, n) {
            state.fullshortlist.splice(n, 1)
        },
        ADD_LIST(state, str) {
            state.myShortlist.push(str)
        },
        SET_SHOW_SHORTLIST(state, bool) {
            state.showShortlist = bool
        },
        SET_FULL_SHORTLIST(state, obj) {
            state.fullshortlist = obj
        },
        SET_MY_SHORTLIST(state, val) {
            state.myShortlist = val;
        },
        DELETE_SHORTLIST(state) {
            state.fullshortlist = []
            state.myShortlist = []
            state.showShortlist = false
        },
    }
}


